import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useParams } from 'react-router-dom';

import { Spinner } from 'components/Loading';
import { getEventInfo } from 'api/events';
import NotFound from 'pages/NotFound';
import RSVP from './RSVP';
import './event.scss';

const VALID_EVENT_TYPES = ['events', 'our-wedding'];

const Event = () => {
  const { type, urlSlug } = useParams();

  const [eventInfo, setEventInfo] = useState();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const getContent = async () => {
      const response = await getEventInfo({ urlSlug, type });
      const { error } = response;
      if (error) {
        setNotFound(true);
        return;
      }
      setEventInfo({ ...response, type });
    };
    if (!VALID_EVENT_TYPES.includes(type)) {
      setNotFound(true);
    }
    getContent();
  }, []);

  const goToOnlineRsvp = (guestId) => {
    window.location = `/online-rsvp/${guestId}`;
  };

  if (notFound) {
    return (
      <NotFound/>
    );
  }

  if (!eventInfo) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'event-page',
      )}
    >
      <RSVP
        eventInfo={eventInfo}
        goToOnlineRsvp={goToOnlineRsvp}
      />
    </div>
  );
};

export default Event;
